import { defineMessages } from 'react-intl';

export const estimationDetailEstimationItemDeleteModalMessageDefinitions = defineMessages({
  title: {
    id: 'estimationDetail.estimationItemDeleteModal.title',
    defaultMessage: 'Deleting Phase',
  },
  warningMessage: {
    id: 'estimationDetail.estimationItemDeleteModal.warningMessage',
    defaultMessage:
      'This will delete the phase and all its sub-phases. The operation cannot be reverted.',
  },
  confirmButton: {
    id: 'estimationDetail.estimationItemDeleteModal.confirmButton',
    defaultMessage: 'Confirm Removing',
  },
});
